export default __webpack_public_path__ + "static/welcome-back-mobile-e6c9c5f0190280152b4d69b4630f4672.webp";